import { TransProp } from '@icc/shared/helpers';
import { RollerGuideSpacerStrip } from './guide-spacer-strip';

/** Prowadzenia */
export class RollerGuidesSpacerStrips {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowdzenie.
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    left: RollerGuideSpacerStrip | null;
    /**
     * Prawe prowadzenie
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    right: RollerGuideSpacerStrip | null;

    /** Prowadzenia podziałowe moskitier */
    mosquitoScreens: {
        spacerStrip: RollerGuideSpacerStrip;
        leftMosquitoScreenId: number | null;
        rightMosquitoScreenId: number | null;
    }[];
}
